import React from 'react';
import { useGetEnerginetReportmappingsQuery } from '../api/rtkApi';
import { MappingSummaryBox } from './MappingSummaryBox';
import {
    BusinessOutlined,
    DescriptionOutlined,
    PeopleOutlined,
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    summaryContainer: {
        marginBlock: theme.spacing(4),
        display: 'flex',
        gap: theme.spacing(2),
        alignItems: 'stretch',
    },
}));

export const MappingSummary = () => {
    const { t } = useTranslation();
    const {
        data = [],
        isLoading,
        isFetching,
    } = useGetEnerginetReportmappingsQuery();

    const classes = useStyles();

    const totalMappings = data.length;
    const mappedWithBygg = data.filter(
        (item) => item.mapping?.byggNummer,
    ).length;
    const mappedWithKunde = data.filter(
        (item) => item.mapping?.kundenummer,
    ).length;
    return (
        <div className={classes.summaryContainer}>
            <MappingSummaryBox
                title={t('reportMapping.mappingsSummary.totalMappings')}
                value={totalMappings}
                icon={<DescriptionOutlined fontSize="large" />}
                isLoading={isLoading || isFetching}
            />
            <MappingSummaryBox
                title={t('reportMapping.mappingsSummary.withBygg')}
                value={mappedWithBygg}
                icon={<BusinessOutlined fontSize="large" />}
                isLoading={isLoading || isFetching}
            />
            <MappingSummaryBox
                title={t('reportMapping.mappingsSummary.withKunde')}
                value={mappedWithKunde}
                icon={<PeopleOutlined fontSize="large" />}
                isLoading={isLoading || isFetching}
            />
        </div>
    );
};
